
export const VIEW_BY = Object.freeze({ 'Member': 1, 'PCP': 2 });
export const VIEW_TYPE = Object.freeze({ 'Master': 4, 'Detail': 8 });


